<template>
  <button
    v-if="show"
    id="scrollTo"
    :class="{ 'move-up': isBottom }"
    class="btn uppercase bg-blue-800 text-white text-base font-semibold rounded-full shadow-lg px-4 text-nowrap"
    @click="scrollToElement"
  >
    <slot
      v-if="$slots.label"
      name="label"
    />
    <span v-else>
      {{ $t('scrollToTopLabel') }}
    </span>
    <span>
      <fa
        class="text-[14px] ml-2"
        icon="arrow-up"
      />
    </span>
  </button>
</template>

<script>
import scrollMixin from '@packages/scroll/mixins/scroll.mixin.js'

export default defineNuxtComponent({
  mixins: [scrollMixin],

  props: {
    offsetToElement: {
      type: Boolean,
      default: false,
    },

    offsetPx: { // px
      type: Number,
      default: -1,
    },

    offsetType: { // ms
      type: String,
      default: '',
    },

    selector: {
      type: String,
      default: '#__nuxt',
    },
  },

  emits: ['showing', 'click'],

  data () {
    return {
      show: false,
      isBottom: false,
    }
  },

  mounted () {
    window.addEventListener('scroll', this.onScrollListener)
  },

  beforeUnmount () {
    window.removeEventListener('scroll', this.onScrollListener)
  },

  methods: {
    scrollToElement () {
      this.$emit('click')
      this.scrollTo(document.querySelector(this.selector))
    },

    onScrollListener () {
      if (!import.meta.browser) {
        return
      }

      let offset = -1
      if (!this.offsetToElement) {
        if (offset < 0 && this.offsetPx >= 0) {
          offset = this.offsetPx
        } else if (offset < 0 && this.offsetType) {
          switch (this.offsetType) {
            case 'viewport': {
              offset = window?.innerHeight
            }
          }
        }
      }

      if (offset >= 0 || this.offsetToElement) {
        const compareTo = this.offsetToElement
          ? document.querySelector(this.selector)?.getBoundingClientRect()?.top * -1
          : window?.scrollY

        const doShow = (compareTo > offset)

        if (this.show && !doShow) {
          this.$emit('showing', false)
        } else if (!this.show && doShow) {
          this.$emit('showing', true)
        }

        this.show = doShow
      }
      this.isBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 80
    },
  },
})
</script>

<style lang="scss" scoped>
#scrollTo {
  position: fixed;
  z-index: 201;

  @media (min-width: theme('screens.lg')) {
    bottom: 3.25rem;
    left: 3.25rem;
  }
  @media (max-width: calc(theme('screens.lg') - 1px)) {
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
  }
  &.move-up {
    bottom: 9rem;
  }
  @media (max-width: 1023px) {
    &.move-up {
      bottom: 1rem;
    }
  }
}
</style>
